/* eslint-disable import/no-anonymous-default-export */
import { Form, Input, Table } from "antd";
import { FilterValue } from "antd/lib/table/interface";
import { useEffect, useState} from "react";
import DataFilter from "../common/components/DataFilter";
import DataTable from "../common/components/DataTable";
import EditableCell from "../common/components/EditableCell";
import MainLayout from "../common/components/MainLayout";
import { ActionResult } from "../common/hooks/useApi";
import useUnidadesProduccionAPI, { UnidadProduccion } from "../unidades-produccion/useUnidadesProduccionAPI";
import useAgentesAPI, { Agente } from "./useAgentesAPI";


export default () => {
    const api = useAgentesAPI();
    const unidadesProduccionApi = useUnidadesProduccionAPI();
    const createPage = "/agentes/guardar"
    const editPage = "/agentes/guardar/{Id}"
    const [unidadesProduccionResponse, setUnidadesProduccionResponse] = useState<ActionResult<UnidadProduccion[]>>();

    const [nombreFilterForm] = Form.useForm();
    const generateFilters = (filters: Record<string, FilterValue | null>) => {
        return [
            filters?.Nombre != null ? `contains(Nombre,'${filters!.Nombre![0]}')` : "",

        ];
    }

    useEffect(() => {
        unidadesProduccionApi
            .list({})
            .then(setUnidadesProduccionResponse)
    }, []);

    return (
        <MainLayout >
            <DataTable<Agente, Agente>
                list={(query)=>api.list({...query,...{}})}
                delete={api.delete}
                createAction={{
                    label: "Agregar agente",
                    path: createPage
                }}
                deleteMultipleAction
                defaultSortOrder={"Apellido desc"}
                selectionType='checkbox'
                title={"Agentes"}
                generateFilters={generateFilters}
                editItemAction={editPage}
                deleteItemAction
                deleteItemActionConfirmMessage={(item) => `¿Eliminar a ${item.Nombre} ${item.Apellido}?`}
                defaultPageSize={25}

            >

                <Table.Column<Agente>
                    width={`25%`}
                    title="Apellido"
                    dataIndex={"Apellido"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<Agente>>
                            save={api.save}
                            id={record.Id}
                            render={(value) => value.Apellido!}
                            formValue={{ Apellido: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Apellido"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    defaultSortOrder={'descend'}
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Apellido"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Apellido...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<Agente>
                    width={`25%`}
                    title="Nombre"
                    dataIndex={"Nombre"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<Agente>>
                            save={api.save}
                            id={record.Id}
                            render={(value) => value.Nombre!}
                            formValue={{ Nombre: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Nombre"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Nombre"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Nombre...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                <Table.Column<Agente>
                    width={`25%`}
                    title="Cargo"
                    dataIndex={"Cargo"}
                    sorter
                    render={(val, record) =>
                        <EditableCell<Partial<Agente>>
                            save={api.save}
                            id={record.Id}
                            render={(value) => value.Cargo!}
                            formValue={{ Cargo: val }}
                            formItem={<Form.Item style={{ marginBottom: 0 }} name={"Cargo"} ><Input maxLength={150} /></Form.Item>}
                            value={record} />
                    }
                    sortDirections={["ascend", "descend", "ascend"]}
                    filterDropdown={(props) => {
                        return (
                            <DataFilter filterDropdownProps={props} form={nombreFilterForm} >
                                <Form.Item name={"Cargo"} style={{ marginBottom: 10 }}>
                                    <Input placeholder='Cargo...'></Input>
                                </Form.Item>
                            </DataFilter>
                        );
                    }
                    }

                />

                    <Table.Column<Agente>
                    width={`25%`}
                    title="Unidad de producción"
                    dataIndex={"UnidadProduccionAgenteId"}
                    align="center"
                    sorter
                    render={(val, record) => {
                        const unidadProduccion = unidadesProduccionResponse?.data?.value.find(
                        unidad => unidad.Id === record.UnidadProduccionAgenteId);
                        return unidadProduccion?.Nombre ?? "-";
                    }}
                    sortDirections={["ascend", "descend", "ascend"]}
                    />

            </DataTable>
        </MainLayout>
    );

};